import { useState } from "react";
import { useEffect } from "react";
import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Image18 from "./img/img_realisations/webp/UNIK SYSTEM PLAFOND & MUR TENDU.webp"
import Image28 from "./img/img_realisations/webp/Mur tendu imprimé design avec motifs de feuilles artistiques dans un salon contemporain – solution décorative Unik System.webp"
import Image3 from "./img/img_realisations/webp/Décoration murale personnalisée astronaute pour hôtel, impression murale Unik System.webp"
import Image4 from "./img/img_realisations/Installation d’un mur tendu imprimé forêt par l’équipe Unik System – pose de toile tendue décorative grand format pour décoration intérieure professionnelle.jpg"
import Image5 from "./img/img_realisations/webp/Installation d’un plafond tendu  profilé mural et insertion de la toile imprimée dans le système de fixation.webp"
// import Image13 from "./img/img_realisations/webp/Installation professionnelle d’une toile murale imprimée forêt et cascade – Pose par l’équipe Unik System – Décoration grand format pour bureaux et espaces intérieurs.webp"
import Image7 from "./img/img_realisations/webp/Mur imprimé décoratif représentant un tunnel végétal 3D, installation mur tendu Unik System.webp"
import Image8 from "./img/img_realisations/Mur lumineux avec toile tendue imprimée paysage de montagne et lac – Éclairage LED intégré – Décoration moderne signée Unik System.webp"
// import Image9 from "./img/img_realisations/webp/Panneaux acoustiques circulaires suspendus au plafond – Solution acoustique décorative pour open space et bureaux – Installation Unik System.webp"
import Image10 from "./img/img_realisations/webp/Plafond acoustique avec îlots circulaires suspendus – solution acoustique moderne en bureaux ou espaces publics par Unik System.webp"
import Image11 from "./img/img_realisations/webp/Plafond tendu 3D effet eau bleue pour chambre design – toile tendue imprimée décorative premium installée par Unik System.webp"
// import Image12 from "./img/img_realisations/webp/Plafond tendu 3D effet eau et océan dans une chambre – Toile imprimée rétroéclairée – Solution décorative immersive par Unik System.webp"
import Image6 from "./img/img_realisations/webp/Plafond tendu arrondi avec impression artistique dans un espace spa – installation premium Unik System.webp"
// import Image14 from "./img/img_realisations/webp/Plafond tendu imprimé 3D effet océan dans un salon moderne lumineux – décoration haut de gamme par Unik System.webp"
// import Image15 from "./img/img_realisations/webp/Plafond tendu imprimé ciel bleu avec perroquets dans une salle de bain moderne, éclairage LED périphérique.webp"
// import Image16 from "./img/img_realisations/webp/Plafond tendu imprimé ciel bleu et fleurs dans un salon de coiffure – Éclairage intégré – Décoration haut de gamme par Unik System.webp"
// import Image17 from "./img/img_realisations/webp/Plafond tendu imprimé ciel bleu et oiseaux blancs dans un salon – décoration immersive Unik System.webp"
// import Image1 from "./img/img_realisations/webp/Plafond tendu imprimé nuages artistiques dans une salle de sport moderne, ciel 3D lumineux par Unik System.webp"
// import Image19 from "./img/img_realisations/webp/1Bloc opératoire moderne avec mur tendu décoratif paysage et plafond rétroéclairé – revêtement hygiénique Unik System.webp"
import Image20 from "./img/img_realisations/webp/2Chambre médicale équipée de murs tendus imprimés paysage et plafond lumineux décoratif – solution hygiène et design Unik System.webp"
import Image21 from "./img/img_realisations/Plafond tendu lumineux imprimé ciel bleu dans un open-space moderne, installation professionnelle Unik System.jpeg"
import Image22 from "./img/img_realisations/webp/Plafond tendu lumineux imprimé motif poissons dans une grande salle moderne, installation professionnelle Unik System.webp"
import Image23 from "./img/img_realisations/webp/Plafonds tendus lumineux imprimés ciel et bambou dans un bureau professionnel moderne.webp"
import Image24 from "./img/img_realisations/webp/3Installation de mur tendu imprimé nature et plafond lumineux tendu dans une salle moderne – Unik System Maroc.webp"
import Image25 from "./img/img_realisations/webp/4Mur tendu décoratif tropical dans une salle d'opération moderne – hygiène et esthétique Unik System.webp"
import Image26 from "./img/img_realisations/webp/5Unités néonatales avec murs tendus imprimés Disney pour ambiance rassurante – solutions médicales Unik System.webp"
import Image27 from "./img/img_realisations/webp/6Plafond tendu imprimé ciel dans salle de scanner médical – environnement apaisant pour patients Unik System.webp"
import Image29 from "./img/img_realisations/webp/7Plafond tendu lumineux décoratif dans salle pour enfants – solution d’éclairage diffus Unik System.webp"
import Image2 from "./img/img_realisations/webp/8Plafond tendu lumineux imprimé ciel dans salle de radiothérapie – atmosphère apaisante Unik System.webp"
// import Image30 from "./img/img_realisations/webp/9Plafond tendu imprimé galaxie spirale 3D dans une chambre luxueuse, ciel étoilé décoratif.webp"





const images = [
  // { id: 1, src: Image1 , title: "Toile tendue imprimée nuages artistiques dans une salle de sport moderne, ciel 3D lumineux" },
  { id: 2, src: Image2 , title: "Plafond lumineux composé de panels imprimés HD, rétroéclairés par LED, montage modulaire sur structure aluminium" },
  { id: 3, src: Image3 , title: "Toile encollée personnalisée astronaute pour hôtel, impression murale HD / UV" },
  { id: 4, src: Image4 ,  title: "Plafond design à éclairage intégré – Élégance, confort et modernité" },
  { id: 5, src: Image5 , title: "Profilé Plat  AP en PVC fixation Plafond" },
  { id: 6, src: Image6  , title: "Plafond tendu arrondi avec impression artistique dans un espace spa – installation premium" },
  { id: 7, src: Image7  , title: "Toile encollée imprimée décorative représentant un tunnel végétal 3D" },
  { id: 8, src: Image8 ,  title: "Mur lumineux avec toile tendue imprimée rétroéclairée - paysage de montagne et lac - Éclairage LED intégré" },
  // { id: 9, src: Image9 ,  title: "Panneaux acoustiques circulaires suspendus au plafond – Solution acoustique décorative pour open space et bureaux" },
  { id: 10, src: Image10 , title: "Plafond la toile tendue PVC laquée effet miroir" },
  { id: 11, src: Image11 ,  title: "Plafond tendu 3D effet eau bleue pour une piscine – toile tendue imprimée décorative premium" },
  // { id: 12, src: Image12 , title: "Toile tendue imprimée ambiance apaisante" },
  // { id: 13, src: Image13 , title: "Mur tendu imprimé paysage de montagne et lac – solution décorative premium pour espaces publics" },
  // { id: 14, src: Image14 , title: "Plafond tendu imprimé lumineux décoratif en toile imprimée rétroéclairée _ effet océan" },
  // { id: 15, src: Image15 , title: "Toile PVC tendue imprimée -atmosphère apaisante" },
  // { id: 16, src: Image16 , title: "Toile tendue imprimée rétroéclairée personnalisée" },
  // { id: 17, src: Image17 , title: "Toile tendue imprimée rétroéclairée personnalisée" },
  { id: 18, src: Image18 , title: "Toile pvc laquée blanche effet miroir" },
  // { id: 19, src: Image19 , title: "Plafond et Mur tendus imprimés - solution décorative premium" },
  { id: 20, src: Image20 , title: "Plafond et Mur tendus imprimés - solution décorative premium" },
  { id: 21, src: Image21 , title: "Plafond tendu lumineux imprimé ciel" },
  { id: 22, src: Image22 , title: "Toile translucide rétroéclairée imprimée" },
  { id: 23, src: Image23 , title: "Plafond et mur tendus rétroéclairé" },
  { id: 24, src: Image24 , title: "Plafond et mur tendus rétroéclairé" },
  { id: 25, src: Image25 , title: "Plafond tendu lumineux imprimé ciel dans salle de radiothérapie – atmosphère apaisante" },
  { id: 26, src: Image26 , title: "Toile encollée imprimée personnalisée Akdital Ainsbaa - ambiance apaisante" },
  { id: 27, src: Image27 , title: "Plafond tendu lumineux imprimé ciel dans salle de radiothérapie" },
  { id: 28, src: Image28 , title: "Toile encollée Imprimée" },
  { id: 29, src: Image29 , title: "Plafond et mur tendus caissons lumineux imprimés HD Akdital" },
  // { id: 30, src: Image30 , title: "Plafond lumineux composé de panels imprimés HD, rétroéclairés par LED" },
];

const Gallery = () => {
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);
  

  return (
    <>
      {/* ===== Title ===== */}
      <div className="container titre-gallry projects-header" id="titre-gallry">
        <h2 data-aos="fade-up" className="section-titles">
          Nos Réalisations – Projets & Installations Professionnelles
        </h2>
        <p data-aos="fade-up">
          Découvrez nos projets réalisés avec expertise et précision.
        </p>
      </div>

      {/* ===== Gallery ===== */}
      <div className="simple-gallery">
        {images.map((img) => (
          <div data-aos="zoom-in" key={img.id} className="gallery-item">
            <img src={img.src} alt={img.title} />

            {/* ✅ Zoom button */}
            <button
              className="zoom-icon"
              onClick={() => setActiveItem(img)}
              aria-label="Zoom image"
              loading="lazy"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>
          </div>
        ))}
      </div>

      {/* ===== Lightbox ===== */}
      {activeItem && (
        <div className="lightbox" onClick={() => setActiveItem(null)}>
          <div className="content" onClick={(e) => e.stopPropagation()}>
            <img src={activeItem.src} alt={activeItem.title} loading="lazy"/>
            
            {/* ✅ TITLE */}
            <div className="image-title">
              {activeItem.title}
            </div>

            <button
              className="close"
              onClick={() => setActiveItem(null)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
